module.exports = __webpack_public_path__ + "img/02.8c80853d.jpg";